import { Symbols } from '@ioc/symbols'

import { BugsnagErrorMonitoring, ErrorMonitoring, IoCContainer } from '@writefull/core'

import { registerBackendApis } from './backend-apis'
import { initializeManagers, registerManagers } from './managers'
import { registerStores } from './stores'

const registerEnvironment = (container: IoCContainer, env: ImportMetaEnv) => {
  container.bind<ImportMetaEnv>(Symbols.ENVIRONMENT).toConstantValue(env as ImportMetaEnv)
}

const registerErrorMonitoring = (container: IoCContainer, env: ImportMetaEnv, version: string) => {
  container
    .bind<ErrorMonitoring>(Symbols.ERROR_MONITORING)
    .toConstantValue(
      new BugsnagErrorMonitoring(env.VITE_BUGSNAG_API_KEY, version, env.VITE_BUGSNAG_STAGE),
    )
}

export const registerInfrastructure = (
  container: IoCContainer,
  env: ImportMetaEnv,
  version: string,
) => {
  registerEnvironment(container, env)
  registerStores(container)
  registerManagers(container)
  registerBackendApis(container, env)
  registerErrorMonitoring(container, env, version)
}

export const initializeInfrastructure = (container: IoCContainer) => {
  initializeManagers(container)
}
